<template>
  <el-popover v-if="data.type == 'bibr'" :placement="popPosition" width="450" trigger="click" :popper-class="[isMobile() ? 'jom-refers-info' : 'jo-refers-info','theme-border']">
    <div class="jo-refer-contents">
      <div class="jo-refer-title">{{ARTICLE.defaultlang=='en'?'Reference' : '参考文献'}} {{ data.text }}</div>
      <!--<div v-html="citation" class="jo-refer-content"></div>-->
      <div class="jo-refer-item" v-for="item in refData">
        <span class="reference-label">{{item.label}}</span>
        <p><span v-for="item2 in item.citation">
            <component v-if="item2.name!='extlink'" :is="'jo' + item2.name" v-bind:key="item2.index"
                       v-bind:data="item2.data"></component>
            <component v-else :is="'jo' + linkItem.name" v-for="linkItem in item2.data.text" v-bind:key="linkItem.index"
                       v-bind:data="linkItem.data"></component>
        </span></p>
        <p><span v-for="item3 in item.citationEn">
          <component v-if="item3.name!='extlink'" :is="'jo' + item3.name" v-bind:key="item3.index"
                     v-bind:data="item3.data"></component>
          <component v-else :is="'jo' + linkItem.name" v-for="linkItem in item3.data.text" v-bind:key="linkItem.index"
                     v-bind:data="linkItem.data"></component>
        </span></p>

        <div class="jo-refer-origin-div">
          <a class="jo-refer-origin" v-if="showGoogle && showLink" :href="'https://scholar.google.com/scholar_lookup?author='+author+'&title='+title" target="_blank">Google Scholar</a>
          <a class="jo-refer-origin" v-if="showBaidu && showLink" v-bind:style="{'color' : ARTICLE.theme}" :href="'https://xueshu.baidu.com/s?wd='+item.title+'&site=xueshu_se'" target="_blank">
            {{ARTICLE.defaultlang=='en'?'Baidu Scholar' : '百度学术'}}&nbsp;&nbsp;&nbsp;&nbsp;</a>
        </div>
      </div>
    </div>
    <span v-if="data.type == 'bibr'" v-bind:style="{'color' : ARTICLE.theme}" class="jo-refer-sup" slot="reference" @click="showDetail()" ref="sup"><nobr>{{ data.text }}</nobr></span>
  </el-popover>
</template>

<script>
  export default {
    data() {
      return {
        refData:[],
        popPosition: 'top',
        author: ''
      }
    },
    props: [
      'data'
    ],
    methods: {
      showDetail() {
        this.refData = [];
        if (this.data.type == 'bibr') {
          for (let k in this.data.rid) {
            let rid = this.data.rid[k];
            let _citation = []
            let _citationEn = []
            let title;
            let label;
            for (var i in this.ARTICLE.reflist.data) {
              if (this.ARTICLE.reflist.data[i].id == rid) {
                label = this.ARTICLE.reflist.data[i].label;
                if (this.ARTICLE.reflist.data[i].citation.length === 1) {
                  _citation = _citation.concat(this.ARTICLE.reflist.data[i].citation[0].text)
                  title=this.setTitle(this.ARTICLE.reflist.data[i].citation[0]);
                }
                else if (this.ARTICLE.reflist.data[i].citation.length > 1) {
                  for (let j in this.ARTICLE.reflist.data[i].citation) {
                    if (this.ARTICLE.reflist.data[i].citation[j].lang === this.ARTICLE.defaultlang) {
                      _citation = _citation.concat(this.ARTICLE.reflist.data[i].citation[j].text)
                      title=this.setTitle(this.ARTICLE.reflist.data[i].citation[j]);
                    } else _citationEn = _citationEn.concat(this.ARTICLE.reflist.data[i].citation[j].text)
                  }
                }
              }
            }
            this.refData.push({
              citation:_citation,
              citationEn:_citationEn,
              title:title,
              label:label
            })
          }
          this.$nextTick(function () {
            if (navigator.userAgent.indexOf('MSIE') > 0 || navigator.userAgent.indexOf('rv:11.0') > 0) {
              $('.el-popper[x-placement^=top].jo-refers-info').css('margin-bottom', '17px')
            }
          })
        }
        if (this.$refs.sup) {
          if (this.$refs.sup.offsetLeft < 225) {
            this.popPosition = 'top-start';
          } else if (this.$refs.sup.offsetLeft > document.getElementById('jobody').offsetWidth - 225) {
            this.popPosition = 'top-end';
          }
        }
      },
      setTitle(citation){
        let title;
        if (citation.title && citation.title !== '') {
          title = citation.title;
        } else {
          for (let i in citation.text) {
            title = title + citation.text[i].data;
          }
        }
        return title;
      },
      isMobile(){
        return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .jo-refer-title {
    font-weight: bold;
    color: #333;
  }

  .jo-refer-contents {
    font-size: 12px;
    line-height: 18px;
    word-wrap: break-word;
    .jo-refer-item{
      word-wrap: break-word;
      .reference-label{
        float: left;
        padding-right: 3px;
        font-size: 1.2rem;
        text-align: right;
        font-weight: bold;
        line-height: 18px;
      }
      p{
        text-indent: 0;
        padding-left: 20px;
        margin: 0;
        font-size: 1.2rem;
        line-height: 18px;
        p{
          padding-left: 0;
        }
      }
    }
  }

  .jo-refer-origin-div{
    white-space: nowrap;
    /*margin-top: 5px;*/
    height: 20px;
  }
  .jo-refer-origin {
    float: right;
    font-size: 12px;
    font-weight: bold;
    /*color: #009999;*/
    text-decoration: none;
    white-space: nowrap;
  }

  .jo-refer-sup {
    color: #00a2af;
    cursor: pointer;
    h2.secTitle & {
      color: #c7f7f4 !important;
    }
  }
  img.jo-fn-sup{
    width: 10px;
    cursor: pointer;
  }

  .jo-refer-sup:hover {
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/commonComponents/blockxref.vue